import Controller from '@ember/controller';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class HeatStartlistController extends Controller
{
	@service store;

	@tracked classGroup = null;

	@action
	selectClassGroup(event)
	{
		var classGroupId = event.target.value;

		if (!classGroupId)
		{
			this.classGroup = null;
		}
		else
		{
			this.store.findRecord('classGroup', classGroupId).then((foundClassGroup) =>
			{
				this.classGroup = foundClassGroup;
			});
		}
	}
}
